module.exports = __webpack_public_path__ + "img/share-bg-20.1258a748.jpg";